module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classnames,
    style: ({
      cursor: _vm.cursor,
      userSelect: _vm.userSelect
    }),
    on: {
      "mousedown": _vm.onMouseDown
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-523c0bbe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/multipane.vue
// module id = 404
// module chunks = 1